var map = {
	"./head_1.png": "06f0",
	"./head_2.png": "0c50",
	"./head_3.png": "6657",
	"./head_4.png": "00f1",
	"./head_5.png": "029d",
	"./head_6.png": "492c",
	"./head_7.png": "e92d",
	"./head_8.png": "c8a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a3d";